export const BLOCK_ELEMENT_TAGS = [
  'div',
  'header',
  'footer',
  'nav',
  'main',
  'section',
  'article',
  'aside',
  'address',
  'figure',
] as const;

export type BlockElementTag = (typeof BLOCK_ELEMENT_TAGS)[number];

export const BOX_VARIANT_TAGS = [
  'div',
  'header',
  'footer',
  'nav',
  'main',
  'section',
  'article',
  'aside',
  'address',
  'figure',
] as const satisfies ReadonlyArray<BlockElementTag>;

export type BoxVariantTag = (typeof BOX_VARIANT_TAGS)[number];

/**
 * Basic plugin icon names for semantic Box tags.
 * Shared by Navigator (`Block` derived icon) and Quick Find presets.
 */
export const BOX_SEMANTIC_TAG_ICON_NAMES = {
  section: 'Section',
  header: 'Header',
  footer: 'Footer',
  nav: 'Nav',
  main: 'Main',
  article: 'Article',
  aside: 'Aside',
  address: 'Address',
  figure: 'Figure',
} as const satisfies Partial<Record<BlockElementTag, string>>;

export type BoxSemanticTag = keyof typeof BOX_SEMANTIC_TAG_ICON_NAMES;
